import uz from './translate-uz'
import ru from './translate-ru'

const lang = {
    uz,
    ru,
}

export default lang